import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    maxWidth: "80px"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
    maxWidth: "80px"
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function PublicEmployeeInternalDatabaseTable(props) {
  const classes = useStyles();
  useTheme();

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }

    return classes.odd;
  };
  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px", marginBottom: "30px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>Tipo de Contrato</TableCell>
            <TableCell className={classes.tableHeader}>Status do Contrato</TableCell>
            <TableCell className={classes.tableHeader}>Nome da Organização</TableCell>
            <TableCell className={classes.tableHeader}>Regime Legal</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.public_employee_data.map((item, index) => (
            <TableRow key={index} className={getClass(index)}>
              <TableCell className={classes.tableText}>
                {item.contract_type ?? "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {item.contract_status ?? "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {item.organization_name ?? "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {item.legal_regime ?? "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default PublicEmployeeInternalDatabaseTable;
